import {useSelector} from "react-redux";
import InputFeedback from "./InputFeedback";

const RadioInput = ({name, label, placeholder, value, handleInputChange, checked=false}) => {

    const errors = useSelector(state => state.errors);


    const renderClass = () => {
        if (Object.entries(errors.errors).length !== 0) {
            if (errors.errors[name]) {
                return "form-check-input form-control is-invalid"
            }

        }

        return "form-check-input"
    }

    const renderLabel = () => {
        if(label) {
            return (<label>{label}</label>)
        }
    }


    return (
        <div className="form-check">
            <input
                type="radio"
                className={renderClass()}
                value={value}
                name={name}
                onChange={handleInputChange}
                checked={checked}
            />
            {renderLabel()}
            <InputFeedback name={name} />

        </div>
    )


};

export default RadioInput;